<template>
  <section class="user-auth">
    <label class="user-auth__label">
      Создайте свой профиль, чтобы комментировать ЖК
    </label>
    <form class="user-auth__form">
      <div class="row">
        <div class="col-md-6 form-group">
          <section class="b-comment-form__upload">
            <label class="button-upload " for="inputfile" v-if="!form.image">
              <i class="button-upload__icon">
                <svg viewBox="0 0 25 25">
                  <use xlink:href="/assets/site/images/sprites.svg?ver=15#sprite-upload"></use>
                </svg>
              </i>
              <span class="button-upload__text">Загрузить фото</span>
              <input type="file" name="file"  id="inputfile" class="button-upload__input" @change="fileChangeHandler" />
            </label>
            <div v-else class="button-upload__preview b-comment-form__preview-wrap">
              <figure class="b-comment-form__preview" :style="{ backgroundImage: `url(${form.image})` }">
              </figure>

              <button class="btn b-comment-form__remove-img-btn" @click="removeImage">Удалить фото</button>
            </div>
          </section>
        </div>
      </div>
        <div class="form-group">
          <input name="name" placeholder="Имя" type="text"
                 v-model="form.name" class="form-control" :class="errors.get('name') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('name')"></div>
        </div>
      <div class="row">
        <div class="form-group col-md-6">
          <input name="email" placeholder="E-mail" type="email"
                 v-model="form.email" class="form-control" :class="errors.get('email') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('email')"></div>
        </div>
        <div class="form-group col-md-6">
          <input name="password" placeholder="Пароль" type="password"
                 v-model="form.password" class="form-control" :class="errors.get('password') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('password')"></div>
        </div>
      </div>
      <div class="user-auth__submit-group user-auth__submit">
        <div class="order-md-1">
          <label class="form-checkbox" :class="errors.get('conf_agree') ? 'is-invalid':''">
          <span class="modal__conf-text">
               Согласен (-на) с
          <a class="landing-questions__link" href="/privacy" target="_blank">политикой
              конфиденциальности.</a>
          </span>
            <input type="checkbox" v-model="form.conf_agree" name="conf_agree" class="form-checkbox__input" checked>
            <span class="form-checkbox__checkmark"></span>
          </label>
          <div class="invalid-feedback" v-text="errors.get('conf_agree')"></div>
        </div>
        <button class="btn button-red user-auth__btn" @click.prevent="register">Зарегистрироваться</button>
      </div>
    </form>
  </section>
</template>
<script>
import { Errors } from  '@/common/services/errors.js';
export default {
  computed: {
    signedIn() {
      return window.App.signedIn;
    },
    user(){
      return  window.App.user
    }
  },
  data() {
    return {
      form: {
        conf_agree:false,
        name:"",
        email:"",
        password:"",
        image:""
      },
      errors: new Errors(),
    }
  },
  methods: {
    register() {
      axios.post('/register', this.form)
          .then((response) => {
            if(response.data.errors) {
              this.errors.record(response.data.errors)
            } else {
              this.$emit('register-user')
            }
          })
          .catch((error) => {
            this.errors.record(error.response.data.errors);
          });
    },
    fileChangeHandler(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      this.form['imageName'] = file.name;
      reader.onload = (e) => {
        vm.form.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.form.image = '';
    },
  },

}
</script>